export default {
      id: "onboard-usage",
      viewBox: "0 0 109 88",
      url: __webpack_public_path__ + "icons/mvm-icons.svg#onboard",
      toString: function () {
        return this.url;
      }
    }